"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var SignupStep = function SignupStep(_ref) {
  var translations = _ref.translations,
      onStepClicked = _ref.onStepClicked,
      isStepValid = _ref.isStepValid,
      values = _ref.values,
      errors = _ref.errors,
      dirty = _ref.dirty,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      touched = _ref.touched;
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.TitleStack, {
    title: "".concat(translations.step, " 3"),
    subtitle: translations.messageSecurityDetails
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    isRequired: true,
    isError: touched.password && errors.password,
    value: values.password,
    name: "password",
    type: "password",
    placeholder: "Password"
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.password && errors.password
  }, errors.password), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    isRequired: true,
    isError: touched.passwordConfirm && errors.passwordConfirm,
    value: values.passwordConfirm,
    name: "passwordConfirm",
    type: "password",
    placeholder: "Confirm Password"
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.passwordConfirm && errors.passwordConfirm
  }, errors.passwordConfirm), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    type: "password",
    name: "pin",
    placeholder: translations.pin,
    value: values.pin,
    isError: touched.pin && errors.pin,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.pin && errors.pin
  }, errors.pin), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    type: "password",
    name: "pinConfirm",
    placeholder: "".concat(translations.confirm, " ").concat(translations.pin),
    value: values.pinConfirm,
    isError: touched.pinConfirm && errors.pinConfirm,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.pinConfirm && errors.pinConfirm
  }, errors.pinConfirm), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: function onClick() {
      return onStepClicked(3);
    },
    disabled: !dirty || !isStepValid,
    style: {
      marginBottom: "1rem"
    }
  }, translations.next), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: function onClick() {
      return onStepClicked(1);
    },
    isDefault: true
  }, translations.back));
};

var _default = SignupStep;
exports.default = _default;